import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Admin impersonation: automatically append ?as_user_id=<id> to data endpoints
// if an admin has selected a user to view.
export function setImpersonatedUser(userId) {
  if (userId) localStorage.setItem("impersonate_user_id", userId);
  else localStorage.removeItem("impersonate_user_id");
}
export function getImpersonatedUser() {
  return localStorage.getItem("impersonate_user_id") || "";
}

api.interceptors.request.use((config) => {
  const impersonate = getImpersonatedUser();
  if (impersonate && !String(config.url || "").startsWith("/admin") && !String(config.url || "").startsWith("/auth")) {
    config.params = { ...(config.params || {}), as_user_id: impersonate };
  }
  return config;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
